import { Outlet } from "react-router-dom";
import { Appbar } from "../components/Appbar";
import { Footer } from "../components/Footer";
import { Sidebar } from "../components/Sidebar";

export const MainLayout = () => {
  return (
    <div className="container-scroller">
      <Appbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <Outlet />
          <Footer />
        </div>
      </div>
    </div>
  );
};
